import './MenuBox.css'

import React from 'react'
import { TimeDHM } from '@/components/Elements/time'
import { secondsToDHM } from '@/common/time'
import { useAppContext } from '@/context/app'
import { useModal } from '@/components/modal/Modal'
import { DailyPopBody } from './menubox/DailyPop'
import { MapRowMachine } from '../../machinestatistic/components/Map/Response'
import { Menu, MenuPopupBody } from '@/popups/menupopup/menu'
import { fetchCSV, fetchExcel } from '@/common/fetch'

const HistoryExportPopup = ({ machine, onClose }: {
  machine: MapRowMachine,
  onClose: () => void
}) => {
  const { services, session, translates } = useAppContext()
  const title = `${machine.type.manufacturer} - ${machine.type.model} - ${machine.internalNumber}`

  const menu: Menu = {
    title: title + ' : ' + translates?.for("popup.export.machine_history_export_title"),
    rows: [
      {
        title: 'popup.export.excel_export',
        action: () => fetchExcel({
          services,
          url: `/api/superadmin/machines/byid/${machine.id}/history/excel`,
          fileName: `${machine.type.manufacturer}_${machine.type.model}_${machine.internalNumber}_history.xlsx`
        })
      },
      {
        title: 'popup.export.csv_export',
        action: () => fetchCSV({
          services,
          url: `/api/superadmin/machines/byid/${machine.id}/history/csv`,
          fileName: `${machine.type.manufacturer}_${machine.type.model}_${machine.internalNumber}_history.csv`
        })
      }
    ]
  }

  return <MenuPopupBody session={session} menu={menu} onClose={onClose} />
}

const HitsExportPopup = ({ machine, onClose }: {
  machine: MapRowMachine,
  onClose: () => void
}) => {
  const { services, session, translates } = useAppContext()
  const title = `${machine.type.manufacturer} - ${machine.type.model} - ${machine.internalNumber}`

  const menu: Menu = {
    title: title + ' : ' + translates?.for("popup.export.machine_hits_export_title"),
    rows: [
      {
        title: 'popup.export.excel_export',
        action: () => fetchExcel({
          services,
          url: `/api/superadmin/machines/byid/${machine.id}/hits/excel`,
          fileName: `${machine.type.manufacturer}_${machine.type.model}_${machine.internalNumber}_hits.xlsx`
        })
      },
      {
        title: 'popup.export.csv_export',
        action: () => fetchCSV({
          services,
          url: `/api/superadmin/machines/byid/${machine.id}/hits/csv`,
          fileName: `${machine.type.manufacturer}_${machine.type.model}_${machine.internalNumber}_hits.csv`
        })
      }
    ]
  }

  return <MenuPopupBody session={session} menu={menu} onClose={onClose} />
}

export const MenuBox = ({ machine, forDay }: {
  machine: MapRowMachine
  forDay: Date
}) => {
  const { translates, session, services } = useAppContext()
  const { openModal } = useModal()

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <div className="communal-statistics-menu-box">
    <a className='main-btn' onClick={() => {
      openModal((props) => DailyPopBody({
        ...props,
        machine: machine,
        day: forDay
      }))
    }}>
      {translates.for('page.statistics.global.box.menu.daily_btn')}
    </a>

    <a className='main-btn' onClick={() => {
      openModal((props) => HistoryExportPopup({ ...props, machine }))
    }}>
      {translates.for('page.statistics.global.box.menu.history_export_btn')}
    </a>
    <a className='main-btn' onClick={() => {
      openModal((props) => HitsExportPopup({ ...props, machine }))
    }}>
      {translates.for('page.statistics.global.box.menu.hits_export_btn')}
    </a>
  </div>
}